import { Component } from '@angular/core';
import { FieldConfig } from 'models/field.interface';
import { FormGroup } from '@angular/forms';
import { UtilityService } from 'services';
@Component({
  templateUrl: './toggle.component.html'
})
export class ToggleComponent {
  field: FieldConfig;
  group: FormGroup;
  constructor(private util: UtilityService) { }
  isRequired() {
    return this.util.isRequired(this.group.get(this.field.name));
  }
}
